import { ONBOARDING_GUIDE_STEPS } from '../../../../../services/exports/Constants';

export default {
  title: 'Démarrage rapide',
  description: 'Suivez ce guide pour un lancement au plus vite',
  steps: {
    [ONBOARDING_GUIDE_STEPS.Notifications]: 'Préférence de notification',
    [ONBOARDING_GUIDE_STEPS.OpenTimesAndLocation]: 'Horaires & Localisation',
    [ONBOARDING_GUIDE_STEPS.Identity]: 'Identité du restaurant',
    [ONBOARDING_GUIDE_STEPS.OrderSettings]: 'Paramètres de commande',
    [ONBOARDING_GUIDE_STEPS.Menu]: 'Configuration du menu',
    [ONBOARDING_GUIDE_STEPS.Marketing]: 'Marketing & Fidélité',
    [ONBOARDING_GUIDE_STEPS.MyStore]: 'Ma boutique',
    [ONBOARDING_GUIDE_STEPS.GoLive]: 'Mise en ligne',
    [ONBOARDING_GUIDE_STEPS.Complete]: 'Terminé',
  },
  toasts: {
    failed_to_load_onboarding: "Échec du chargement des étapes d'intégration",
  },
};
